/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Button, createStyles, LoadingOverlay, Text } from "@mantine/core";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import useSWR from "swr";
import * as yup from "yup";
import { OtpApi } from "../../apis";
import { Form } from "../../components/form";
import { TextField } from "../../components/form/text-field";
import { authChange } from "../../store/Auth";
import HttpHandler from "../../utils/http-handler";
import { Message } from "../../utils/message";

type IForm = {
  otp: string | undefined;
};

const schema = yup.object({
  otp: yup.string().required("Заавал бөглөнө"),
});

export function VerifyForm() {
  const { classes } = useStyles();
  const [loading, setLoading] = React.useState<boolean>(false);
  const { accessToken } = useSelector((state: any) => state.auth);
  const dispatch = useDispatch();

  const { data: OTP, error } = useSWR<any>(
    "swr.otp.verify",
    async () => {
      try {
        const res = await OtpApi.get({ otpMethod: "REGISTER" });
        Message.success(res?.message);
      } catch (err: any) {
        Message.error((err as HttpHandler)?.message!);
      }
    },
    {
      revalidateOnFocus: false,
      revalidateOnMount: true,
      revalidateOnReconnect: false,
      refreshWhenOffline: false,
      refreshWhenHidden: false,
      refreshInterval: 0,
    },
  );

  const [data] = React.useState<IForm>({
    otp: undefined,
  });

  const onSubmit = async (values: IForm) => {
    setLoading(true);

    try {
      const res = await OtpApi.verify({ otpMethod: "REGISTER", otpCode: values?.otp as string });

      dispatch(authChange(res));
      setLoading(false);
      Message.success("Баталгаажуулалт амжилттай");
    } catch (err) {
      Message.error((err as HttpHandler)?.message!);
      setLoading(false);
    }
  };

  return (
    <div className={classes.card}>
      {accessToken ? (
        <Form initialValues={data} validationSchema={schema} onSubmit={onSubmit}>
          {() => {
            return (
              <div className={classes.card}>
                <LoadingOverlay visible={loading} />
                <div className={classes.icon}></div>
                <Text className={classes.title}>Баталгаажуулах код</Text>
                <Text align="center" className={classes.bodyText}>
                  Таны бүртгэлтэй дугаар-руу явуулсан 4 оронтой тоог доорх талбарт оруулж мэдээлэлээ баталгаажуулна уу
                </Text>
                <TextField className={classes.input} name="otp" radius={5} size="md" placeholder="Баталгаажуулах код..." />
                <Button type="submit" variant="gradient" radius={5} size="md" className={classes.button} gradient={{ from: "pink.6", to: "indigo.4" }}>
                  Баталгаажуулах
                </Button>
              </div>
            );
          }}
        </Form>
      ) : (
        <>
          {error ? (
            <>
              <LoadingOverlay visible={loading} />
              <div className={classes.icon}></div>
              <Text color="red" className={classes.title}>
                Баталгаажуулахад алдаа гарлаа
              </Text>
              <Text align="center" className={classes.bodyText}>
                Таны бүртгэлийг хийхэд алдаа гарлаа. Таньд илгээсэн баталгаажуулах холбоос зөвхөн нэг л удаа баталгаажуулахыг анхаарна уу
              </Text>
              <Button variant="gradient" radius={4} size={"md"} className={classes.button} gradient={{ from: "pink.6", to: "indigo.4" }}>
                Test
              </Button>
            </>
          ) : (
            <Box h={420}>
              <Text align="center" fw={500}>
                Түр хүлээнэ үү...
              </Text>
            </Box>
          )}
        </>
      )}
    </div>
  );
}

const useStyles = createStyles((theme) => ({
  container: {
    maxWidth: "1600px",
    margin: "auto",
    display: "flex",
    flexDirection: "column",
    paddingTop: 80,
    alignItems: "center",
    justifyContent: "center",
    paddingBottom: 80,
    paddingLeft: 30,
    paddingRight: 30,
  },
  row: {
    display: "flex",
    flexDirection: "row",
  },
  background: {
    position: "absolute",
    height: "100vh",
    opacity: 0.8,
    bottom: 0,
    zIndex: -1,
  },
  card: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "white",
    height: 420,
    maxWidth: 624,
    borderRadius: 10,
    gap: 10,
    position: "relative",
  },
  title: {
    fontSize: 26,
    fontWeight: 700,
    color: "black",
  },
  bodyText: {
    width: "80%",
    fontSize: 16,
    fontWeight: 400,
    paddingRight: 15,
    paddingLeft: 15,
    color: "black",
  },
  input: {
    marginTop: 25,
    width: "60%",
  },
  button: {
    marginTop: 15,
  },
  bottomText: {
    marginTop: 25,
    color: "white",
  },
  icon: {},
}));
